export { default } from './ReceivePaymentView';
